import { render, staticRenderFns } from "./ClaimRequestListTable.vue?vue&type=template&id=acf848b0&"
import script from "./ClaimRequestListTable.vue?vue&type=script&lang=js&"
export * from "./ClaimRequestListTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimRequestListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports